import React, { Component } from 'react'
import MainPane from './components/mainPane'
class Home extends Component {
    constructor(props) {
        super(props)

        this.state = {
           
        }
    }


    componentDidMount = () => {
      
    }
    render() {
        return (
            <div>

                <MainPane />

            </div>
        )
    }
}
export default Home